const { $businessApiUrl, $request } = window.React;
export const flowRecord = (params) => $request.get(`${$businessApiUrl}/workflow/flowRecord`, params);
export const startFlow = (params) => $request.get(`${$businessApiUrl}/workflow/start/flow`, params);
export const revokeFlow = (params) => $request.get(`${$businessApiUrl}/workflow/revoke`, params);
